import axios from "axios";
import { getHeaders } from "services/AuthHeader";

const API_URL = process.env.REACT_APP_API_URL;

export async function updateUserAccountService(user_data, email) {
    try {

        // console.log('update User Account Service'.toUpperCase());
        // console.log(user_data);
        
        const response = await axios.post(
            API_URL + '/user/update_account',
            {
                user_data: user_data,
                old_email: email
            },
            {
                headers: getHeaders()
            }
        )
        // console.log(response);
        if ('error' in response.data) {
            throw Error
        }
        return response.data.user
    } catch(error) {
        return "update_user_account_error"
    }
}